/** @format */
/*global google */

import React, { useCallback, useState, useEffect } from "react";
import {
  GoogleMap,
  MarkerF,
  Polygon,
  InfoWindow,
  useJsApiLoader,
} from "@react-google-maps/api";
import debounce from "debounce";
import { PropertyMapPopup } from "./Property2";

import pin_gray from "../../img/pin_gray.png";

const MapComponent = ({
  center,
  drawCenter,
  drawBounds,
  onMapMounted,
  address,
  boundsChangedCallback,
  markers = null,
  markerOnClick = null,
}) => {
  const [showInfo, setShowInfo] = useState();
  const [showAddress, setShowAddress] = useState();
  const [currentZoom, setCurrentZoom] = useState(7);
  
  const markerClick = (m) => setShowInfo(m.sourceid);
  const markerClear = () => setShowInfo(undefined);

  const debouncedBoundsChanged = debounce(boundsChangedCallback, 200);

  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GMAPS_API_KEY, // ,
    // ...otherOptions
  });

  useEffect(() => {

    const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    if ((address !== "USA") && (address !== "United States")) 
    setCurrentZoom(screenWidth < 768 ? 7 : 10);
    else
    setCurrentZoom(3);

  }, [address]);

  const onLoad = useCallback(
    function onLoad(mapInstance) {
      // do something with map Instance

      onMapMounted && onMapMounted(mapInstance);
      setShowAddress(address);
      
    },
    [onMapMounted]
  );

  if (loadError) {
    return <div>Unable to load map.</div>;
  }
  if (!isLoaded) {
    return <div>Loading map...</div>;
  }


  return (
    <>
 
    <GoogleMap
      mapContainerStyle={{
        width: "100%",
        height: "100%",
      }}
      onLoad={onLoad}
      zoom={currentZoom}
      center={center}
      options={{ fullscreenControl: false, scaleControl: true,
        mapTypeControl: true, // Enable map type control
        mapTypeId: google.maps.MapTypeId.HYBRID, // Set the default map type to satellite
        mapTypeIds: [google.maps.MapTypeId.SATELLITE, google.maps.MapTypeId.HYBRID],
      }}
      onBoundsChanged={debouncedBoundsChanged}
      mapContainerClassName={"mapContainer"}
    >
      {drawCenter && (
        <MarkerF
          key={"center"}
          position={center}
          icon={{
            path: google.maps.SymbolPath.CIRCLE,
            scale: 5,
            fillColor: "#F48A3D",
            fillOpacity: 1,
            strokeColor: "#F48A3D",
            strokeOpacity: 1,
          }}
        />
      )}
      {markers &&
        markers.map((m) => (
          <MarkerF
            key={m.sourceid}
            position={{ lat: m.lat, lng: m.lng }}
            onClick={() => markerClick(m)}
            title={m.title}
            icon={
              m.available || (m.availableSpaces && m.availableSpaces.length > 0)
                ? undefined
                : pin_gray
            }
          >
            {showInfo && showInfo === m.sourceid && (
              <InfoWindow>
                <PropertyMapPopup
                  key={m.wtweb_id}
                  className="propertyThumbnailMap pointer"
                  property={m}
                  onClick={() => {
                    markerClear();
                    markerOnClick(m);
                  }}
                />
              </InfoWindow>
            )}
          </MarkerF>
        ))}
      {drawCenter && drawBounds && (
        <Polygon
          paths={[
            drawBounds.getNorthEast(),
            {
              lat: drawBounds.getNorthEast().lat(),
              lng: drawBounds.getSouthWest().lng(),
            },
            drawBounds.getSouthWest(),
            {
              lat: drawBounds.getSouthWest().lat(),
              lng: drawBounds.getNorthEast().lng(),
            },
            drawBounds.getNorthEast(),
          ]}
          defaultOptions={{
            fillColor: "#F48A3D",
            fillOpacity: 0.15,
            strokeColor: "#F48A3D",
            strokeOpacity: 0.5,
          }}
        />
      )}
    </GoogleMap>
    
    </>
  );
};

export default MapComponent;
